export default __webpack_public_path__ + "static/media/number3.08a2de4f.svg";